import { trackTealiumEvent } from '@/tracking'

export default (userLocale: string) => {
  trackTealiumEvent({
    screen_title: 'signup/welcome',
    eventCategory: 'signup',
    eventAction: 'select language',
    eventLabel: userLocale,
    tealium_event: 'select language',
  })
}
